import { createFileRoute, redirect } from "@tanstack/react-router";

import { ContactStep } from "~/pages/onboard/steps/contact-step";
import { activeOrganization$ } from "~/stores/organizations";

/**
 * Post-invite "contact us" step. Org-level and datasource-agnostic, so it's a
 * flat route with no `$datasourceId` param.
 *
 * Accepts `"invite"` and `"contact"` so a navigation from `/onboard/invite`
 * after Continue isn't bounced during the brief window before
 * `setOrgOnboardingStep("contact")` resolves. Continue advances to `boards`.
 */
export const Route = createFileRoute("/onboard/contact")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "done") {
      throw redirect({ to: "/onboard", replace: true });
    }
    const org = activeOrganization$.get();
    if (!org?.id) {
      throw redirect({ to: "/onboard", replace: true });
    }
    if (org.onboarding !== "invite" && org.onboarding !== "contact") {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: ContactStep,
});
